// Configuration.
import { chart, theme } from '../config';

// Formulas.
import formulas, {
  getInterestRate,
  getAccumulationPeriods,
  getAccumulationOutput,
} from './formulas';

//------------------------------------------------------------------------------

const calculateChartData = ({
  salary,
  period,
  status,
  exemptions,
  deferrals,
}) => {
  // Clone config to avoid mutations and destructure.
  const { legend, options } = Object.assign({}, chart);

  // Prepare x-axis.
  const labels = getAccumulationPeriods.map(
    num => (num === 0 ? 'Start' : `${num} Years`),
  );

  // Prepare areas.
  const datasets = legend.map(({ uid, content, swatch }) => ({
    uid,
    label: content,
    data: [],
    backgroundColor: swatch,
    borderColor: 'transparent',
    pointBackgroundColor: theme.colors.default,
    pointRadius: 2,
  }));

  // Assign default props.
  const props = {
    data: {
      labels,
      datasets,
    },
    options,
  };

  const areas = props.data.datasets;

  // New data coming in, recalculate and reassign new values.
  if (salary && period && status && deferrals) {
    // Core calculations.
    const formulasObj = formulas(salary, period, status, exemptions, deferrals);

    // Variable references.
    const interestRate = getInterestRate;
    const payOccurances = formulasObj.payOccurances;
    const reductionsOutput = formulasObj.reductionsOutput;
    const contributionsOutput = formulasObj.contributionsOutput;

    // Calculate 'accumulations' and reassign <Chart /> values.
    for (let i = 0; i < areas.length; i += 1) {
      const area = areas[i];
      switch (area.uid) {
        case 'reductions':
          area.data = getAccumulationPeriods.map(accumulationPeriod =>
            getAccumulationOutput(
              reductionsOutput,
              payOccurances,
              accumulationPeriod,
            ),
          );
          break;
        case 'contributions':
          area.data = getAccumulationPeriods.map(accumulationPeriod =>
            getAccumulationOutput(
              contributionsOutput,
              payOccurances,
              accumulationPeriod,
            ),
          );
          break;
        case 'savings':
          area.data = getAccumulationPeriods.map(accumulationPeriod =>
            getAccumulationOutput(
              contributionsOutput,
              payOccurances,
              accumulationPeriod,
              interestRate,
            ),
          );
          break;
        default:
          break;
      }
    }
  }

  return props;
};

export default calculateChartData;



// WEBPACK FOOTER //
// ./src/utils/calculateChartData.js